function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import { AMANDA_AGENT_ID } from "./11labs-convai-widget-config";
export const VoiceAgent11LabsEmbeddedAdvancedConfig = {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, SharedAdvancedFieldsConfig)
};
export default {
    type: FIELD_TYPES.NESTED,
    label: "11Labs Voice Agent",
    fields: {
        agentId: {
            type: FIELD_TYPES.TEXT,
            label: "11Labs Agent ID",
            defaultValue: AMANDA_AGENT_ID
        },
        disableDefaultLeadData: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Disable Default Lead Data"
        }
    }
};
